import React, { useState, useEffect, useCallback } from 'react';
import { fetchDoctorByOrder } from '../Services/apiService';

const FindDoctorByOrder = () => {
  const [order, setOrder] = useState('');
  const [doctor, setDoctor] = useState(null);

  const handleOrderChange = (event) => {
    setOrder(event.target.value);
  };

  const handleFindDoctor = useCallback(
    async () => {
      try {
        const data = await fetchDoctorByOrder(order);
        if (data) {
          setDoctor(data); // Set fetched doctor
          console.log('Doctor by order:', data);
          console.log('Doctor by order:', JSON.stringify(data, null, 2));
        } else {
          setDoctor(null); // No doctor found
        }
      } catch (error) {
        console.error('Error fetching doctor:', error);
        setDoctor(null);
      }
    },
    [order],
  );

  useEffect(() => {
    if (order) handleFindDoctor();
  }, [handleFindDoctor, order]);

  return (
    <div>
      <h2>Find Doctor by Order</h2>
      <input
        type="text"
        placeholder="Enter order"
        value={order}
        onChange={handleOrderChange}
      />
      <button type="button" onClick={handleFindDoctor}>
        Find Doctor
      </button>
      {doctor && (
        <div>
          <h3>Doctor Details</h3>
          <pre>{JSON.stringify(doctor, null, 2)}</pre>
        </div>
      )}
    </div>
  );
};

export default FindDoctorByOrder;
